import { Server, Activity, LayoutGrid } from 'lucide-react'
import LocationRacks from './LocationRacks'
import { ActivityLogs, LocationItems } from '../Shared'

export const tabs = (_location: any) => [
    {
        label: 'Racks',
        value: 'racks',
        startIcon: <LayoutGrid className="text-primary w-4 h-4" />,
        component: <LocationRacks />,
    },
    {
        label: 'Items at Location',
        value: 'items',
        startIcon: <Server className="text-primary w-4 h-4" />,
        component: <LocationItems />,
    },
    {
        label: 'Activity Logs',
        value: 'logs',
        startIcon: <Activity className="text-primary w-4 h-4" />,
        component: <ActivityLogs entityType="location" />,
    },
]
